import script from "./CheckoutConfirmPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutConfirmPage.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutConfirmPage.vue?vue&type=style&index=0&id=e20f3280&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e20f3280"]])

export default __exports__